
    (window.__NEXT_P = window.__NEXT_P || []).push([
      "/features/flow",
      function () {
        return require("private-next-pages/features/flow.tsx");
      }
    ]);
    if(module.hot) {
      module.hot.dispose(function () {
        window.__NEXT_P.push(["/features/flow"])
      });
    }
  